import store from '@/store'

export const RTC_TYPE = {
  TRTC: 'trtc',
  TRTC_ELECTRON: 'trtc_electron',
  VOLC: 'volc',
  VOLC_ELECTRON: 'volc_electron',
}

export const RTC_CONTTECTION_STATE = {
  default: 0,
  connected: 1,
  reconnecting: 2,
}
export const RTC_PROFILE = {
  40: {
    profile: 'standard',
    label: '标准-40kbps',
  },
  64: {
    profile: 'standard-stereo',
    label: '标准立体声-64kbps',
  },
  128: {
    profile: 'high',
    label: '高质量-128kbps（默认）',
  },
  192: {
    profile: 'high-stereo',
    label: '高质量立体声-192kbps',
  },
}

export const VOLCENGINE_RTC_PROFILE = {
  40: 0, // AudioProfileType.default,
  64: 4, // AudioProfileType.standardStereo,
  128: 5, // AudioProfileType.hdMono,
  192: 3, // AudioProfileType.hd,
}

export const VOLCELECTRON_RTC_PROFILE = {
  40: 2,
  64: 4,
  128: 5,
  192: 3,
}

export const RTC_PROFILE_V5 = {
  40: 'standard', // TRTC.TYPE.AUDIO_PROFILE_STANDARD,
  64: 'standard-stereo', // TRTC.TYPE.AUDIO_PROFILE_STANDARD_STEREO,
  128: 'high', // TRTC.TYPE.AUDIO_PROFILE_HIGH,
  192: 'high-stereo', // TRTC.TYPE.AUDIO_PROFILE_HIGH_STEREO	,
}

export const TRTC_ELECTRON_PROFILE = {
  40: {
    sampleRate: 48000,
    channel: 1,
    bitrate: 50,
  },
  64: {
    sampleRate: 48000,
    channel: 2,
    bitrate: 50,
  },
  128: {
    sampleRate: 48000,
    channel: 1,
    bitrate: 128,
  },
  192: {
    sampleRate: 48000,
    channel: 2,
    bitrate: 192,
  },
}

export const TRTC_ELECTRON_BGM_EXPERIMENTAL_API = [
  {
    // 使用192双声道码率
    api: 'setAudioQualityEx',
    params: TRTC_ELECTRON_PROFILE[192],
  },
]

export const PHONE_MIC_ID = 'Phone-Microphone'
export const RTC_ABILITY = {
  BGM: 'bgm',
  PHONE_MIC: 'phone_mic',
  SCREEN_SHARE: 'screen_share',
}

export const BGM_WINDOWS_VERSION = '10.0.19041.0'
export const TRTC_BGM_EXCLUDE_WINDOWS_VERSION = '10.0.19044.0'
export const PROCESS_ARCH = {
  UNKNOWN: 0,
  x86: 1,
  x64: 2,
}
export const REPORT_SCREEN_SHARE_TYPE = {
  STOP: 0,
  START: 1,
  EDIT: 2,
}

export const USER_ADDITION_SUFFIX = '#addition' // 用户辅流（屏幕共享）id后缀
export function ADD_USER_ADDITION_SUFFIX(user_id) {
  user_id = String(user_id)
  return user_id.replace(/#addition/g, '') + '#addition'
}
export function REMOVE_USER_ADDITION_SUFFIX(user_id) {
  user_id = String(user_id)
  return user_id.replace(/#addition/g, '')
}
export function IS_USER_ADDITION(user_id) {
  return user_id.endsWith('#addition')
}

export const USER_BGM_SUFFIX = '#bgm' // 用户共享伴奏id后缀
export function ADD_USER_BGM_SUFFIX(user_id) {
  user_id = String(user_id)
  return user_id.replace(/#bgm/g, '') + '#bgm'
}
export function REMOVE_USER_BGM_SUFFIX(user_id) {
  user_id = String(user_id)
  return user_id.replace(/#bgm/g, '')
}
export function IS_USER_BGM(user_id) {
  return user_id.endsWith('#bgm')
}

export function CHECK_USER_IN_ID_LIST(user_id, idMap) {
  return !!(idMap && idMap[REMOVE_USER_ADDITION_SUFFIX(REMOVE_USER_BGM_SUFFIX(user_id))])
}

export const RTC_DEFAULT_RUNTIME_PARAMETERS = {
  trtc: '{"api":"setPrivateConfig","params":{"configs":[{"key":"Liteav.Audio.windows.hardware.3a.enabled","value":"1","default":"1"}]}}',
  trtc_close: '{"api":"setPrivateConfig","params":{"configs":[{"key":"Liteav.Audio.windows.hardware.3a.enabled","value":"0","default":"0"}]}}',
  volc: '{"rtc.audio_system_process":{"bypass_capture":false}}',
  volc_close: '{"rtc.audio_system_process":{"bypass_capture":true}',
}

export const RTC_AV_LINE_LIST_DEFAULT = [
  {
    name: '线路1',
    value: 'trtc',
    resolution_map: {
      480: {
        width: 640,
        height: 480,
        bitrate: 1100,
        min_bitrate: 600,
      },
      720: {
        width: 1280,
        height: 720,
        bitrate: 1500,
        min_bitrate: 1000,
      },
      1080: {
        width: 1920,
        height: 1080,
        bitrate: 2500,
        min_bitrate: 2000,
      },
      1440: {
        width: 2560,
        height: 1440,
        bitrate: 5000,
        min_bitrate: 3500,
      },
      2160: {
        width: 3840,
        height: 2160,
        bitrate: 10000,
        min_bitrate: 7000,
      },
    },
  },
  {
    name: '线路2',
    value: 'volc',
    resolution_map: {
      480: {
        width: 640,
        height: 480,
        bitrate: 7000,
        min_bitrate: 5000,
      },
      720: {
        width: 1280,
        height: 720,
        bitrate: 8000,
        min_bitrate: 6000,
      },
      1080: {
        width: 1920,
        height: 1080,
        bitrate: 9000,
        min_bitrate: 7000,
      },
      1440: {
        width: 2560,
        height: 1440,
        bitrate: 15000,
        min_bitrate: 12000,
      },
      2160: {
        width: 3840,
        height: 2160,
        bitrate: 25000,
        min_bitrate: 20000,
      },
    },
  },
]

export const RTC_MIC_MULT_POWER_DEFAULT = {
  trtc_web: 2,
  trtc_electron: 1,
  volc_web: 2,
  volc_electron: 2
}


export const HEYCHAT_WINDOW_NAME = 'heybox-chat-electron'

export const TRTC_AI_DENOISER_VERSION = {
  2: {
    api: 'setPrivateConfig',
    params: {
      configs: [
        {
          key: 'Liteav.Audio.common.ans.version',
          value: '2',
          default: '2',
        },
      ],
    },
  },
  3: {
    api: 'setPrivateConfig',
    params: {
      configs: [
        {
          key: 'Liteav.Audio.common.ans.version',
          value: '4',
          default: '2',
        },
      ],
    },
  },
}

export const TRTC_AI_DENOISER_TYPE = {
  1: {
    api: 'setAudioAINSStyle',
    params: {style: 1},
  },
  2: {
    api: 'setAudioAINSStyle',
    params: {style: 2},
  },
}

export const TRTC_AI_DENOISER_VERSION_VALUE_MAP = {
  v2: 2,
  v3: 3,
}

export const TRTC_AI_DENOISER_VERSION_OPTIONS = [
  {
    label: 'v2.0',
    value: TRTC_AI_DENOISER_VERSION_VALUE_MAP.v2,
  },
  {
    label: 'v3.0 (Beta)',
    value: TRTC_AI_DENOISER_VERSION_VALUE_MAP.v3,
    options: 'type',
  }
]

export const TRTC_AI_DENOISER_TYPE_OPTIONS = [
  {
    label: '强力消除',
    value: 1,
  },{
    label: '语音保护',
    value: 2,
  },
]

export const TRTC_SCREEN_SHARE_PROTOCAL = {
  udp: { api: 'setFixedTransportProtocol', params: { protocol: 1 } },
  tcp: { api: 'setFixedTransportProtocol', params: { protocol: 2 } },
}

export const TRTC_SCREEN_SHARE_ENCODE = {
  hardware: { api: 'setVideoEncodeParamEx', params: { codecType: 1, streamType: 2 } },
  software: { api: 'setVideoEncodeParamEx', params: { codecType: 0, streamType: 2 } },
}

// trtc 声音阈值db转化volume打表，通过trtcDbToVolume函数传递 -100 - 0 的值生成
export const TRTC_DB_TO_VOLUME_TABLE = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 4, 4, 5, 5, 6, 7, 8, 9, 10, 11, 13, 14, 16, 18, 20, 23, 26, 29, 32, 36, 40, 43, 45, 49, 51, 53, 55, 58, 60, 63, 66, 69, 73, 78, 85, 91, 94, 97, 100]

export const BILIBILI_LIVING_PREVENT_WATCH_SCREENSHARE_TEXT = '该用户未实名认证，为保障直播内容安全，在B站直播期间，将无法观看该用户的屏幕共享'

// rtc 预录制时长
export const RTC_PRE_AUDIO_RECORD_DURATION = 100 * 1000

// rtc 预录制切片时长
export const RTC_PRE_AUDIO_RECORD_BLOCK_DURATION = 5 * 1000

// rtc 预录制队列最大值
export const RTC_PRE_AUDIO_RECORD_BLOCK_COUNT = 20

// TRTC 耳返3A
export const TRTC_EAR_MONITOR_3A = {
  api: "enableEarMonitoringEffect",
  params: {
    "includeEffects": 1,
  },
}
